<h2 mat-dialog-title>{{ isEdit ? 'Erlös-Suffix bearbeiten' : 'Erlös-Suffix anlegen' }}</h2>
<mat-dialog-content class="dialog-content">
    <p class="hint">
        Suffix an Artikel-Basis: Praxis <strong>8401</strong>, Labor <strong>8402</strong>
        (z.&nbsp;B. Hähnchenmast → {{ previewPraxis }} / {{ previewLabor }}).
        <br />
        <strong>LIVE erst ab 1.1.2027</strong> (Belegdatum) – bis dahin Primanota ohne Suffix;
        Pflege jetzt schon möglich.
    </p>
    <div class="one-row">
        <mat-form-field class="flex">
            <mat-label>Suffix</mat-label>
            <input matInput [formControl]="suffixCtrl" placeholder="11" />
        </mat-form-field>
        <mat-form-field class="flex">
            <mat-label>Praxis</mat-label>
            <input matInput [value]="previewPraxis" readonly />
        </mat-form-field>
        <mat-form-field class="flex">
            <mat-label>Labor</mat-label>
            <input matInput [value]="previewLabor" readonly />
        </mat-form-field>
    </div>
    <mat-form-field class="full">
        <mat-label>Bezeichnung</mat-label>
        <input matInput [formControl]="bezeichnungCtrl" />
    </mat-form-field>
    <div class="ba-field">
        <kiene-autocomplete
            (elementSelected)="setBetriebsart($event)"
            [apiUrl]="'betriebsart/'"
            [displayFields]="['bezeichnung']"
            [focus]="false"
            [kieneObject]="betriebsart"
            [placeholder]="'Betriebsart'"
            [required]="false"
        ></kiene-autocomplete>
    </div>
    <div class="one-row">
        <mat-form-field class="flex">
            <mat-label>Sortierung</mat-label>
            <input matInput type="number" [formControl]="sortierungCtrl" />
        </mat-form-field>
        <div class="flex aktiv-wrap">
            <mat-checkbox [formControl]="aktivCtrl">Aktiv</mat-checkbox>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button type="button" (click)="cancel()">Abbrechen</button>
    <button mat-flat-button color="primary" type="button" [disabled]="!isValid()" (click)="save()">
        Speichern
    </button>
</mat-dialog-actions>
